import { render, staticRenderFns } from "./GroupAuths.vue?vue&type=template&id=228315d5&scoped=true&"
import script from "./GroupAuths.vue?vue&type=script&lang=js&"
export * from "./GroupAuths.vue?vue&type=script&lang=js&"
import style0 from "./GroupAuths.vue?vue&type=style&index=0&id=228315d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228315d5",
  null
  
)

export default component.exports